import { IMAGES } from "./images";

// Category and variety names are language-neutral to protect proper flower names.
export const CATEGORIES = [
  {
    id: "roses",
    name: "Roses",
    countEn: "150+ varieties",
    countRu: "150+ сортов",
    image: IMAGES.catRoses,
    span: "lg:col-span-2 lg:row-span-2",
    descriptionEn:
      "Our flagship collection. High-altitude roses with large heads, strong stems and exceptional vase life.",
    descriptionRu:
      "Наша флагманская коллекция. Высокогорные розы с крупными бутонами, крепкими стеблями и исключительной стойкостью.",
    featured: ["Pink Mondial", "Esperance", "Rosita Vendela"],
  },
  {
    id: "garden-like-roses",
    name: "Garden Like Roses",
    countEn: "60+ varieties",
    countRu: "60+ сортов",
    image: IMAGES.catGarden,
    span: "",
    descriptionEn:
      "Full, layered blooms with a romantic, old-world silhouette — a favourite for luxury weddings.",
    descriptionRu:
      "Пышные многослойные бутоны с романтичным классическим силуэтом — фавориты роскошных свадеб.",
    featured: ["White O'Hara", "Sweet Bliss", "Mother of Pearl"],
  },
  {
    id: "spray-roses",
    name: "Spray Roses",
    countEn: "50+ varieties",
    countRu: "50+ сортов",
    image: IMAGES.catSpray,
    span: "",
    descriptionEn:
      "Multi-head stems that add texture and volume to arrangements and installations.",
    descriptionRu:
      "Стебли с несколькими бутонами, придающие композициям и инсталляциям фактуру и объём.",
    featured: ["Sweet Cake", "Shocking Blue", "Twilight"],
  },
  {
    id: "alstroemerias",
    name: "Alstroemerias",
    countEn: "30+ varieties",
    countRu: "30+ сортов",
    image: IMAGES.catAlstro,
    span: "",
    descriptionEn:
      "Delicate, long-lasting blooms in a wide palette — ideal for volume and colour work.",
    descriptionRu:
      "Нежные стойкие цветы в широкой палитре — идеальны для объёмных и цветовых композиций.",
    featured: ["Opala", "Topaz", "Proud"],
  },
  {
    id: "ranunculus",
    name: "Ranunculus",
    countEn: "20+ varieties",
    countRu: "20+ сортов",
    image: IMAGES.catRanunculus,
    span: "",
    descriptionEn:
      "Paper-thin petals in tight, elegant layers — a designer favourite for editorial work.",
    descriptionRu:
      "Тончайшие лепестки, собранные в изящные слои — любимый выбор дизайнеров для съёмок.",
    featured: ["Nena", "Tiffany", "Sweetness"],
  },
  {
    id: "other-flowers",
    name: "Other Flowers",
    countEn: "Browse all",
    countRu: "Смотреть все",
    image: IMAGES.catOther,
    span: "lg:col-span-2",
    descriptionEn:
      "A curated selection of complementary flowers to complete any international program.",
    descriptionRu:
      "Отборные дополнительные цветы для завершения любой международной программы поставок.",
    featured: ["Exotix Mint", "Star Platinum", "Polo"],
  },
];
